var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.route)?_c('page-header',{attrs:{"title":"View Route","breadcrumb":"Dashboard >> Settings >> Routes >> Route"}}):_vm._e(),(_vm.route)?_c('div',{staticClass:"custom-card"},[(_vm.isIntrastate)?_c('intra-state-form',{attrs:{"states":_vm.states,"route":_vm.route,"edit":""}}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }